export class BroadcastingBasic {

    broadcastingInternalId: string;
    broadcastingName: string;
    active: boolean;
    broadcastingInitialDate: number;
    broadcastingEndDate: number;
    numberOfDevice: string;
    numberOfVideo: string;
    numberOfImage: string;

    constructor(broadcastingInternalId?: string, broadcastingName?: string, active?: boolean, broadcastingInitialDate?: number, broadcastingEndDate?: number, numberOfDevice?: string, numberOfVideo?: string, numberOfImage?: string) {
        this.broadcastingInternalId = broadcastingInternalId;
        this.broadcastingName = broadcastingName;
        this.active = active;
        this.broadcastingInitialDate = broadcastingInitialDate;
        this.broadcastingEndDate = broadcastingEndDate;
        this.numberOfDevice = numberOfDevice;
        this.numberOfVideo = numberOfVideo;
        this.numberOfImage = numberOfImage;
    }

    public get BroadcastingInternalId() {
        return this.broadcastingInternalId;
    }
    public get BroadcastingName() {
        return this.broadcastingName;
    }
    public get Active() {
        return this.active;
    }
    public get BroadcastingInitialDate() {
        return this.broadcastingInitialDate;
    }
    public get BroadcastingEndDate() {
        return this.broadcastingEndDate;
    }
    public get NumberOfDevice() {
        return this.numberOfDevice;
    }
    public get NumberOfVideo() {
        return this.numberOfVideo;
    }
    public get NumberOfImage() {
        return this.numberOfImage;
    }
    public set BroadcastingInternalId(broadcastingInternalId) {
        this.broadcastingInternalId = broadcastingInternalId;
    }
    public set BroadcastingName(broadcastingName) {
        this.broadcastingName = broadcastingName;
    }
    public set Active(active) {
        this.active = active;
    }
    public set BroadcastingInitialDate(broadcastingInitialDate) {
        this.broadcastingInitialDate = broadcastingInitialDate;
    }
    public set BroadcastingEndDate(broadcastingEndDate) {
        this.broadcastingEndDate = broadcastingEndDate;
    }
    public set NumberOfDevice(numberOfDevice) {
        this.numberOfDevice = numberOfDevice;
    }
    public set NumberOfVideo(numberOfVideo) {
        this.numberOfVideo = numberOfVideo;
    }
    public set NumberOfImage(numberOfImage) {
        this.numberOfImage = numberOfImage;
    }
}
